/**
 * As flags de produto de Operação › Configurações, lidas por usuário (uid e
 * e-mail). Cada página segue com a flag da aba que ela substituiu em Compras
 * ou em Entregas; o menu mostra a seção com qualquer uma delas. Arquivo sem
 * import: o menu lateral (bundle principal) o importa.
 */

/** Prazo de entrega e Compra automática: a da antiga aba "Controle de automação de compra". */
export const PURCHASE_SETTINGS_FLAG =
  'showIntegratedPurchaseProvidersToggleTab';

/** Logística automática: a da antiga aba "Controle de acionamento automático de logística". */
export const LOGISTICS_SETTINGS_FLAG =
  'showIntegratedLogisticsProvidersToggleTab';

/** Quem vê a seção: qualquer uma das duas. */
export const OPERATION_SETTINGS_FLAGS: readonly string[] = [
  PURCHASE_SETTINGS_FLAG,
  LOGISTICS_SETTINGS_FLAG,
];
